export default __webpack_public_path__ + "static/media/13-EXT-(1-2).dd225b82.jpg";